import { useState, useEffect } from 'react';
import { portalApi } from '../../api';

export default function PortalInventory() {
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => { portalApi('/inventory').then(setRows).catch(() => {}); }, []);

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-bold text-emerald-800">📊 我的库存</h2>
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-emerald-50 text-slate-500 text-left">
              <th className="p-3">产品</th><th>单位</th><th>当前库存</th><th>状态</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const isLow = (r.current_stock ?? 0) < 10;
              return (
                <tr key={r.id} className={`border-t ${isLow ? 'bg-red-50' : ''}`}>
                  <td className="p-3 font-medium">{r.product_name}<div className="text-xs text-slate-400">{r.code}</div></td>
                  <td className="p-3">{r.unit || '—'}</td>
                  <td className="p-3 font-bold">{r.current_stock ?? 0}</td>
                  <td className="p-3">
                    {isLow
                      ? <span className="text-xs px-2 py-1 rounded-full bg-red-100 text-red-700">⚠️ 库存偏低</span>
                      : <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-700">充足</span>}
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-slate-400">暂无库存数据</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-400">库存低于 10 时将提醒您及时补货。</p>
    </div>
  );
}
